import React from "react";
import { Box, Button } from "@mui/material";
import { getGlassActionButtonSx } from "../theme/spatial";

/**
 * The gallery "Share" pill as a component, so the label typography, leading
 * icon treatment and hover / focus / active behavior can be dropped anywhere
 * else in the product without being re-derived at the call site.
 *
 * `variant="ghost"` (default) is the secondary fill — transparent with
 * shadowed white text; `variant="solid"` is the white glass fill used for the
 * single most-prominent action in a row. Both share geometry, so swapping a
 * button between them causes no layout shift.
 */
const iconSlotSx = {
  lineHeight: 0,
  display: "flex",
  color: "inherit",
  "& svg": {
    width: 18,
    height: 18,
    color: "inherit",
  },
};

export default function GlassActionButton({
  variant = "ghost",
  icon = null,
  sx,
  children,
  ...buttonProps
}) {
  return (
    <Button
      variant="contained"
      color="inherit"
      disableElevation
      startIcon={icon ? <Box sx={iconSlotSx}>{icon}</Box> : undefined}
      sx={[
        getGlassActionButtonSx({ variant }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...buttonProps}
    >
      {children}
    </Button>
  );
}
